export function sharePromptRewardMessage(t, { platformPoints = 0, restaurantPoints = 0 } = {}) {
  const platform = Math.max(0, Math.floor(Number(platformPoints) || 0));
  const restaurant = Math.max(0, Math.floor(Number(restaurantPoints) || 0));
  if (platform > 0 && restaurant > 0) {
    return t("tastes.sharePromptRewardBodyBoth", { platform, restaurant });
  }
  if (platform > 0) {
    return t("tastes.sharePromptRewardBodyPlatform", { points: platform });
  }
  if (restaurant > 0) {
    return t("tastes.sharePromptRewardBodyRestaurant", { points: restaurant });
  }
  return null;
}
